import APIRequest from "./APIRequest";

/**
 * Fetch list of all curated playlists
 * Route: GET /list-playlist
 */
export const listPlaylists = (params = {}) => {
  return APIRequest.get("list-playlist", params);
};

/**
 * Fetch details of a specific playlist including its product tracks
 * Route: GET /playlist/{id}/show
 */
export const getPlaylistDetail = (id, params = {}) => {
  return APIRequest.get(`playlist/${id}/show`, params);
};
